import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@env";
import { KeycloakService } from "keycloak-angular";

@Component({
  selector: "app-ada-access-authoring-tools",
  templateUrl: "./ada-access-authoring-tools.component.html",
  styleUrls: ["./ada-access-authoring-tools.component.scss"],
})
export class AdaAccessAuthoringToolsComponent {
  sidebarActive: boolean = true;

  constructor(
    private keycloakservice: KeycloakService,
    private router: Router
  ) {}
  user = "";
  async ngOnInit() {
    const userInfo = await this.keycloakservice.loadUserProfile();
    this.user = userInfo?.username || null;
  }

  aacPolicyAuth() {
    this.router.navigate(["ada-access/auth-tools/risk-score-authoring"]);
  }
  assetAuthoring() {
    this.router.navigate(["ada-access/auth-tools/asset/search"]);
  }
  accessFlowAuth() {
    this.router.navigate(["ada-access/auth-tools/access-flow/search"]);
  }

  adaptiveAccessNodeAuth() {
    this.router.navigate(["ada-access/auth-tools/adaptiveaccessnode/search"]);
  }

  adaptiveAccessNodeConf() {
    this.router.navigate([
      "ada-access/auth-tools/adaptiveaccessnodeconfiguration/search",
    ]);
  }

  logout(): void {
    this.keycloakservice.logout( environment.keyCloakRedirectUrl);
  }
  back() {
    this.router.navigate(["ada-access/aac-tools"]);
  }

  dashboard() {
    this.router.navigate(["ada-access/auth-tools"]);
  }
}
